"use strict";
function activatePackageSelector() {
    var baseUrl = 'https://tickets.waballet.com.au/packages/flex/';
    var paths = {
        2: 453,
        3: 454,
        4: 455,
        5: 456,
        6: 457,
    };
    var getUrl = function (count) {
        var numberOfSelectedPackages = Math.min(6, count);
        if (numberOfSelectedPackages >= 2) {
            return "" + baseUrl + paths[numberOfSelectedPackages];
        }
    };
    document.querySelectorAll('.packages').forEach(function (packages) {
        var button = packages.querySelector('.buy-now');
        var alert = packages.querySelector('.alert');
        if (button && alert) {
            var buttonLabel_1 = button.querySelector('.buy-now--label');
            var inputs_1 = packages.querySelectorAll('.package-toggle');
            inputs_1.forEach(function (input) {
                input.addEventListener('change', function () {
                    var performance = input.nextElementSibling;
                    performance.title = (input.checked ? 'De-select' : 'Select') + " this performance";
                    var count = Array.from(inputs_1).reduce(function (c, i) { return (i.checked ? c + 1 : c); }, 0);
                    if (buttonLabel_1) {
                        buttonLabel_1.textContent = count + " ballets";
                    }
                    alert.classList.toggle('opacity-0', count >= 2);
                    alert.classList.toggle('scale-90', count >= 2);
                    button.classList.toggle('disabled', count < 2);
                    button.href = getUrl(count) || '#';
                });
            });
        }
    });
}
// Function to check if the cookie exists
function checkCookie(name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
function setModalSetCookie(seconds) {
    var d = new Date();
    d.setTime(d.getTime() + (seconds * 1000)); // Convert seconds to milliseconds
    var expires = "expires=" + d.toUTCString();
    document.cookie = "modalSet=true; " + expires + ";path=/";
}
document.addEventListener("keydown", escapeModal, false);
function openModal() {
    document.body.classList.add('stop-scrolling');
    var modal = document.getElementById('ackModal');
    if (modal) {
        modal.style.display = "block";
        setTimeout(function () {
            modal.style.opacity = "1";
        });
    }
}
function closeModal() {
    document.body.classList.remove('stop-scrolling');
    var modal = document.getElementById('ackModal');
    if (modal) {
        modal.style.opacity = "0";
        setTimeout(function () {
            modal.style.display = "none";
        }, 500); // Needs to be in sync with duration
        setModalSetCookie(86400); // 1 Day
    }
}
function escapeModal(evt) {
    var keyCode = evt.keyCode;
    if (keyCode == 27) { // Escape key.
        closeModal();
    }
}
// Expose so can be referenced in twig
window.openModal = openModal;
window.closeModal = closeModal;
window.addEventListener('load', function () {
    activatePackageSelector();
    // Check if 'modalSet' cookie is not set
    if (!checkCookie('modalSet')) {
        openModal(); // Call the openModal function if cookie is not found
    }
});
